module.exports = __webpack_public_path__ + "static/media/anc5ru.5b42c265.pdf";